import { Role } from '@customTypes/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/auth/login')({
  beforeLoad: ({ context }) => {
    const role = context.auth.profile?.role.toLowerCase() as
      | 'admin'
      | 'artist'
      | 'clubowner';
    if (
      context.auth.isAuthenticated &&
      context.auth.profile?.role === Role.admin
    ) {
      throw redirect({
        to: `/${role as 'admin'}/kanban`,
        throw: true
      });
      return;
    }
    if (context.auth.isAuthenticated && context.auth.profile?.profileIds[0]) {
      throw redirect({
        to: `/${context.auth.profile?.role.toLocaleLowerCase() as 'artist'}/$id/profile`,
        params: {
          id: context.auth.profile?.profileIds[0].toString()
        }
      });
    }
  }
});
